import { svgstore } from '../lib/svgstore'

// link
for (const el of document.querySelectorAll('.vp-block-text-media .link a')) {
    el.innerHTML += svgstore('arrow-button')
}

let blocks
if (
    (blocks = document.querySelectorAll(
        '.vp-page-article .vp-blocks .vp-block-text-media'
    ))
) {
    if (blocks[0]?.nextElementSibling?.classList.contains('vp-block-anchor')) {
        blocks[0].classList.add('has-background')
    }
}
